import { useEffect, useState } from 'react'

import SwaggerUI from 'swagger-ui-react'

import { getRequestInterceptor, useSwaggerScroll } from './helper'
import { ExplorePlugin } from '~/components/ApiViewer/ExplorePlugin'
import { LastModifiedDatePlugin } from '~/components/LastModifiedDate'
import { useUser } from '~/hooks/useUser'
import { SHUBApiDetails } from '~/types/api'
import { OpenAPI2Definition, OpenAPI3Definition } from '~/types/api.definitions'

interface SwaggerRendererProps {
  definition: OpenAPI2Definition | OpenAPI3Definition,
  containerRef: HTMLDivElement | undefined,
  hash: string,
  exploreUrl?: string,
  SHUBApiDetails: SHUBApiDetails
  oasVersion: string
  lastModifiedDate?: string
}

export default function SwaggerRenderer({ definition, containerRef, hash, exploreUrl, SHUBApiDetails, oasVersion, lastModifiedDate }: SwaggerRendererProps) {

  const [oauth2RedirectUrl, setOauth2RedirectUrl] = useState<string>('')

  useEffect(() => {
    setOauth2RedirectUrl(`${window.location.protocol}//${window.location.host}/oauth2_redirect`)
  }, [])

  useSwaggerScroll(containerRef, hash)

  const { user } = useUser()

  const { version = '', orgName: swaggerhubOrgName = '', name: swaggerhubApiName = '' } = SHUBApiDetails

  const plugins = [
    exploreUrl ? ExplorePlugin({ exploreUrl, version, swaggerhubOrgName, swaggerhubApiName, oasVersion }) : null,
    LastModifiedDatePlugin({ lastModifiedDate })
  ].filter(Boolean)

  return (
    oauth2RedirectUrl ? <SwaggerUI 
      key={`swaggerUI-${swaggerhubOrgName}-${swaggerhubApiName}-${version}`}
      spec={definition}
      requestSnippetsEnabled={true}
      plugins={plugins}
      requestInterceptor={getRequestInterceptor(user)}
      showMutatedRequest={false}
      oauth2RedirectUrl={oauth2RedirectUrl}
    /> : null
  )
}